export type RecentReviewProof = {
  author: string;
  quote: string;
  sourceUrl: string;
  sourceNotificationDate: string;
};

// Exact, complete-sentence excerpts from Google's five-star review notifications.
// Dates record notification receipt, not independently verified publication dates.
// Listing links were checked on Google Maps; they do not claim to open one review.
// Keep this selection in sync with SingingAttitude.com's recentReviewProof.ts.
export const recentReviewProof = [
  {
    author: "Kevin Grimwood",
    quote: "I was very nervous as I have only sang around the house but Liuba made me feel at ease.",
    sourceUrl: "https://www.google.com/maps?cid=16707810918563830550",
    sourceNotificationDate: "2026-10-13",
  },
  {
    author: "Miguel Guila",
    quote: "Had an evaluation session with Liuba and really enjoyed it.",
    sourceUrl: "https://www.google.com/maps?cid=16707810918563830550",
    sourceNotificationDate: "2026-10-08",
  },
  {
    author: "Jordan Culling",
    quote: "Liuba is an incredible vocal coach!",
    sourceUrl: "https://www.google.com/maps?cid=16707810918563830550",
    sourceNotificationDate: "2026-10-06",
  },
  {
    author: "Sany Farajalla",
    quote: "Really good! So much covered in a very short time.",
    sourceUrl: "https://www.google.com/maps?cid=10254114574968933341",
    sourceNotificationDate: "2026-07-15",
  },
  {
    author: "Michelle Pfeiffer",
    quote: "I really enjoyed my singing lesson.",
    sourceUrl: "https://www.google.com/maps?cid=10254114574968933341",
    sourceNotificationDate: "2026-06-05",
  },
] satisfies RecentReviewProof[];
